import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { PaginatedPackageCategoryAutoCompleteList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompletePackageCategory {
  search?: string;
}

function useAutoCompletePackageCategory({
  search,
}: IUseAutoCompletePackageCategory): UseQueryResult<
  AxiosResponse<PaginatedPackageCategoryAutoCompleteList>
> {
  const fetchAutoCompletePackageCategory = (): Promise<
    AxiosResponse<PaginatedPackageCategoryAutoCompleteList>
  > => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    return client.get(`package-categories/auto_complete/?${encodeUrlParams(params)}`);
  };

  return useQuery(['packageCategory', search], fetchAutoCompletePackageCategory);
}

export default useAutoCompletePackageCategory;
